<form #f="ngForm" novalidate>
  <div class="d-flex align-items-center justify-content-between formborder">
    <div class="col-md-6 mb-2">
      <form action="" class="search-text">
        <div class="bg-light rounded rounded-pill shadow-sm">
          <div class="input-group">
            <input
              type="text"
              id="FilterInputSearch"
              (keyup)="applyFilter($event.target.value)"
              name="FilterInputSearch"
              placeholder="What're you searching for?"
              class="form-control border-0 bg-light mt-2"
            />
            <div class="input-group-append">
              <button
                id="button-addon1"
                type="submit"
                class="btn btn-link text-primary"
              >
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</form>
<div class="table-responsive mt-1">
  <mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="Id">
      <mat-header-cell
        mat-sort-header
        class="grid-header"
        style="max-width: 6.25rem"
        *matHeaderCellDef
      >
        #
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        class="grid-cell"
        style="max-width: 6.25rem"
      >
        {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Group_Ratio_Name">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Group Ratio Name
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Group_Ratio_Name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Group_Names">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Group Names
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Group_Names }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Account_Names">
      <mat-header-cell
        mat-sort-header
        class="grid-header"
        style="max-width: 15.625rem; padding-left: 0.625rem"
        *matHeaderCellDef
      >
        Account Names
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row"
        class="grid-cell"
        style="max-width: 15.625rem; padding-left: 0.625rem"
      >
        {{ row.Account_Names }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="EditAction">
      <mat-header-cell
        mat-sort-header
        class="grid-header"
        style="max-width: 4.375rem"
        *matHeaderCellDef
      >
        Action
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 4.375rem">
        <i
          class="fas fa-lg fa-edit margin-right-4xs cursor-style"
          (click)="onEdit(row)"
          style="cursor: pointer"
          aria-label="true"
        ></i>
      </mat-cell>
    </ng-container>

    <!-- Header and Row Declarations -->
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
  <mat-paginator
    #paginatorRef
    [pageSizeOptions]="[20, 50]"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
<div
  class="modal fade in"
  id="EditGroupRatioModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <form #f="ngForm" (ngSubmit)="onSaveGroup()" novalidate>
    <div class="modal-dialog" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            Edit Group Ratio Master
          </h6>
          <button
            type="button"
            (click)="OnClose()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body formborder m-3">
          <div class="row m-0">
            <div class="col-md-4 p-1">
              <span> Group Ratio Name: </span>
            </div>
            <div class="col-md-8 p-1">
              <input
                type="text"
                [(ngModel)]="groupRationame"
                placeholder="Product Category"
                name="groupRationame"
                id="groupRationame"
                class="form-control input-text-css mt-2"
                disabled
              />
            </div>
          </div>

          <div class="row m-0" *ngIf="showdropdown == false">
            <div class="col-md-4 p-1">
              <span class="required-lable"> Group Name : </span>
            </div>
            <div class="col-md-8 p-1">
              <!-- Multi-select dropdown for Group Name -->
              <ng-multiselect-dropdown
                name="accGroup"
                [placeholder]="'Select Group Name'"
                [data]="groupDropdown"
                [settings]="groupDropdownSettings"
                [(ngModel)]="selectedGroups"
                (onDeSelect)="onGroupSelect($event)"
                (onSelect)="onGroupSelect($event)"
                #accGroup="ngModel"
                required
                [ngClass]="{
                  'is-invalid': f.submitted && accGroup.invalid,
                  'alert-warning':
                    accGroup.invalid && (accGroup.dirty || accGroup.touched)
                }"
              >
              </ng-multiselect-dropdown>
              <div
                *ngIf="f.submitted && accGroup.invalid"
                class="invalid-feedback d-block"
              >
                Group Name is required
              </div>
            </div>
          </div>

          <div *ngIf="showdropdown == true" class="row m-0">
            <div class="col-md-4 p-1">
              <span class="required-lable"> Account Head Name : </span>
            </div>
            <div class="col-md-8 p-1">
              <!-- Multi-select dropdown for Account Head Name -->
              <ng-multiselect-dropdown
                name="accHead"
                [placeholder]="'Select Account Head'"
                [data]="AccountHeadDropdown"
                [settings]="accountHeadDropdownSettings"
                [(ngModel)]="selectedAccountHeads"
                (onDeSelect)="onAccountHeadSelect($event)"
                (onSelect)="onAccountHeadSelect($event)"
                #accHead="ngModel"
                required
                [ngClass]="{
                  'is-invalid': f.submitted && accHead.invalid,
                  'alert-warning':
                    accHead.invalid && (accHead.dirty || accHead.touched)
                }"
              >
              </ng-multiselect-dropdown>
              <div
                *ngIf="f.submitted && accHead.invalid"
                class="invalid-feedback d-block"
              >
                Account Head Name is required
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="border: none">
          <button
            type="button"
            (click)="OnClose()"
            class="mt-3 btn font-size-12 button-btn"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="mt-3 btn font-size-12 button-btn"
            [disabled]="f.invalid"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
